import type { NextPage } from 'next'
import Head from 'next/head'
import { PoliticaDePrivacidade } from 'src/views'

const PoliticaDePrivacidadePage: NextPage = () => {
  return (
    <>
      <Head>
        <meta charSet="UTF-8" />

        <title>Política de Privacidade - Crédito One</title>

        <meta
          property="og:description"
          content="Veja como tratamos seus dados pessoais e seus direitos (LGPD)."
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="pt_BR" />
        <meta property="og:site_name" content="Crédito One" />
        <meta
          property="og:title"
          content="Política de Privacidade - Crédito One"
        />

        <meta
          name="description"
          content="Veja como tratamos seus dados pessoais e seus direitos (LGPD)."
        />
        <meta
          property="og:image"
          content="https://uploads-ssl.webflow.com/5fb18514177e609c5101c5b2/61aa78267b898128a13bbb31_open%20graph.png"
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <PoliticaDePrivacidade />
    </>
  )
}

export default PoliticaDePrivacidadePage


